import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Planbook } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import { heroPatterns } from "cc-frontend/utils/planbook-covers"
import styles from "./pattern-menu.module.css"

interface Signature {
  Args: {
    planbook: Planbook
    selectPattern: (pattern: string | null) => void
    selectedPattern: string | null
    selectedBackground: string
    closeMenu: Function
  }
}

export default class PatternMenuComponent extends Component<Signature> {
  readonly styles = styles

  @service("ember-store") declare store: EmberStore

  patterns = heroPatterns
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Planbook::TitleBackground::PatternMenu": typeof PatternMenuComponent
  }
}
